<div class="row g-3 mb-4">
  <div class="col-lg-6 col-md-6">
    <app-metric-card
      [title]="data() ? data()!.month_label + ' Floor' : 'Current Month Floor'"
      [currentValue]="data() ? ('$' + (data()!.floor_amount | number: '1.0-0')) : '—'"
      [hideComparison]="true"
      [hidePrevious]="!data()?.inherited"
      [showLeftBorder]="true"
      [leftBorderColor]="data()?.inherited ? 'var(--gray-500)' : 'var(--bootstrap-primary)'"
      [isLoading]="isLoading()"
      [showLastUpdated]="!!data()?.last_updated"
      [lastUpdatedDate]="data()?.last_updated ?? null"
    >
      <!-- Inherited floors are rendered muted + italic with an "Inherited" pill so they read as
           the parent's commitment, not this org's own. Non-inherited renders as the plain value. -->
      <ng-template #value>
        <div
          class="metric-value d-flex align-items-center gap-2"
          [class.is-inherited]="data()?.inherited"
        >
          <span>{{ data() ? ('$' + (data()!.floor_amount | number: '1.0-0')) : '—' }}</span>
          @if (data()?.inherited) {
            <span class="badge rounded-pill fw-normal inherited-badge">Inherited</span>
          }
        </div>
      </ng-template>

      <ng-template #subtext>
        @if (data()?.inherited) {
          <div class="text-muted fst-italic small">
            Floor held at {{ data()?.held_by_name }} (this org has no contract of its own)
          </div>
        }
      </ng-template>
    </app-metric-card>
  </div>
  <div class="col-lg-6 col-md-6">
    <app-metric-card
      [title]="'Active Sub-Customers'"
      [currentValue]="data()?.active_sub_customer_count ?? '—'"
      [hideComparison]="true"
      [hidePrevious]="true"
      [showLeftBorder]="true"
      [leftBorderColor]="'var(--bootstrap-success)'"
      [isLoading]="isLoading()"
    ></app-metric-card>
  </div>
</div>
